import { render, staticRenderFns } from "./quality-img.vue?vue&type=template&id=46b897ac"
import script from "./quality-img.vue?vue&type=script&lang=js"
export * from "./quality-img.vue?vue&type=script&lang=js"
import style0 from "./quality-img.vue?vue&type=style&index=0&id=46b897ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports